import { Checkbox as CheckboxAria, CheckboxProps } from 'react-aria-components';
import DoneCheckmark from '@/assets/Icons/Done-Checkmark.svg?react';
import styles from './Checkbox.module.scss';
import classNames from 'classnames';
import MinusIcon from '@/assets/Icons/Minus.svg?react';

interface CheckboxPropsExtended extends CheckboxProps {
	showRemoveIcon?: boolean;
}

const Checkbox = ({ children, className, showRemoveIcon, ...props }: CheckboxPropsExtended) => {
	const isMarked = props.isSelected || props.isIndeterminate;

	return (
		<CheckboxAria {...props} className={classNames(styles.ariaCheckbox, className)}>
			<>
				<div className={styles.checkbox}>
					{isMarked &&
						(showRemoveIcon || props.isIndeterminate ? (
							<div className={styles.minusIcon}>
								<MinusIcon />
							</div>
						) : (
							<DoneCheckmark />
						))}
				</div>
				{children}
			</>
		</CheckboxAria>
	);
};

export default Checkbox;
